import {iosVhFix} from './utils/ios-vh-fix';
import {initModals} from './modules/modals/init-modals';
import {initAccordions} from './modules/init-accordion';
import {initTabs} from './modules/init-tabs';
// ---------------------------------

window.addEventListener('DOMContentLoaded', () => {

  // Utils
  // ---------------------------------

  iosVhFix();

  // Modules
  // ---------------------------------

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    // initModals();
    initAccordions();
    initTabs();

    let aboutSlider = document.querySelector('.new-about__slider');
    if(aboutSlider) {
      let swiper = new Swiper(aboutSlider, {
        slidePerView: 1,
        loop: true,
        effect: "fade",
        pagination: {
          el: '.new-about-nav',
          clickable: true,
        },
        autoplay: {
          delay: 5000,
        },
      })
    }

    let goodSliders = document.querySelectorAll('.good__slider');
    if(goodSliders) {
      goodSliders.forEach(function(slider) {
        let swiper = new Swiper(slider, {
          navigation: {
            prevEl:  slider.closest('.good__slider-wrapper').querySelector('.good__slider-btn.--prev'),
            nextEl:  slider.closest('.good__slider-wrapper').querySelector('.good__slider-btn.--next')
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 60,
            },
            1220: {
              slidesPerView: 2,
              spaceBetween: 90,
            }
          }
        });
      });
      
    }


    var tl = gsap.timeline({repeat: -1, repeatDelay: 0, yoyo: true});
    tl.to('.--cloud-1', {
      x: '-150%',
      duration: 15
    });
    // ScrollTrigger.create({
    //   trigger: '.--cloud-1',
    //   start: 'top 60%',
    //   endTrigger: '.--last',
    //   end: 'bottom 100%',
    //   animation: tl,
    //   scrub: true
    // });

    var tl2 = gsap.timeline({repeat: -1, repeatDelay: 0, yoyo: true});
    tl2.to('.--cloud-2', {
      x: '100%',
      y: '50%',
      duration: 10
    });
    // ScrollTrigger.create({
    //   trigger: '.--cloud-2',
    //   start: 'top 60%',
    //   endTrigger: '.--last',
    //   end: 'bottom 100%',
    //   animation: tl2,
    //   scrub: true
    // });

    var tl3 = gsap.timeline({repeat: -1, repeatDelay: 0, yoyo: true});
    tl3.to('.--cloud-3', {
      x: '-100%',
      y: '-30%',
      duration: 10
    });
    // ScrollTrigger.create({
    //   trigger: '.--cloud-3',
    //   start: 'top 60%',
    //   endTrigger: '.--last',
    //   end: 'bottom 100%',
    //   animation: tl3,
    //   scrub: true
    // });

    var tl4 = gsap.timeline({repeat: -1, repeatDelay: 0, yoyo: true});
    tl4.to('.--cloud-4', {
      x: '100%',
      y: '20%',
      duration: 10
    });
    // ScrollTrigger.create({
    //   trigger: '.--cloud-4',
    //   start: 'top 60%',
    //   endTrigger: '.--last',
    //   end: 'bottom 100%',
    //   animation: tl4,
    //   scrub: true
    // });

    var tl5 = gsap.timeline({repeat: -1, repeatDelay: 0, yoyo: true});
    tl5.to('.--cloud-5', {
      x: '-30%',
      y: '20%',
      duration: 10
    });
    // ScrollTrigger.create({
    //   trigger: '.--cloud-5',
    //   start: 'top 60%',
    //   endTrigger: '.footer',
    //   end: 'bottom 100%',
    //   animation: tl5,
    //   scrub: true
    // });

  });

  const anchors = document.querySelectorAll('a[href*="#"]')
  for (let anchor of anchors) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault()
      const blockID = anchor.getAttribute('href').substr(1)
      
      document.getElementById(blockID).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    })
  }

});

// ---------------------------------

// ❗❗❗ обязательно установите плагины eslint, stylelint, editorconfig в редактор кода.

// привязывайте js не на классы, а на дата атрибуты (data-validate)

// вместо модификаторов .block--active используем утилитарные классы
// .is-active || .is-open || .is-invalid и прочие (обязателен нейминг в два слова)
// .select.select--opened ❌ ---> [data-select].is-open ✅

// выносим все в дата атрибуты
// url до иконок пинов карты, настройки автопрокрутки слайдера, url к json и т.д.

// для адаптивного JS используейтся matchMedia и addListener
// const breakpoint = window.matchMedia(`(min-width:1024px)`);
// const breakpointChecker = () => {
//   if (breakpoint.matches) {
//   } else {
//   }
// };
// breakpoint.addListener(breakpointChecker);
// breakpointChecker();

// используйте .closest(el)
